import { Resource } from '../../../common/constants/resource';

export enum TaskTypes {
  DECISION = 'DECISION',
  OVERVIEW = 'OVERVIEW',
  SUMMARY = 'SUMMARY',
  PIA = 'PIA',
  NOTES = 'NOTES',
  APS = 'APS',
  EHR = 'EHR',
  ETI = 'ETI',
  MEDEXAM = 'MEDEXAM',
  TRL = 'TRL',
  MVR = 'MVR',
  MIB = 'MIB',
  LETTER = 'LETTER',
  OTAF_LETTER = 'OTAF_LETTER',
  DECLINE_LETTER = 'DECLINE_LETTER',
  RX = 'RX',
  DISCLOSURE = 'DISCLOSURE',
  QE_DISCLOSURE = 'QE_DISCLOSURE',
  MIB_CODEBACK = 'MIB_CODEBACK',
  ORDER_MIB_CODEBACK = 'ORDER_MIB_CODEBACK',
  LAB_PIQTURE = 'LAB_PIQTURE',
  MEDICAL_CLAIMS = 'MEDICAL_CLAIMS',
  SCRIPT_CHECK = 'SCRIPT_CHECK',
  MIB_CODE_DETAILS = 'MIB_CODE_DETAILS',
  INSURANCE_LABS = 'INSURANCE_LABS',
  CRIMINAL_RECORDS = 'CRIMINAL_RECORDS',
  SUBSTANDARD_LETTER = 'SUBSTANDARD_LETTER',
  DOCTOR_INFO = 'DOCTOR_INFO',
  RULE_RESULTS = 'RULE_RESULTS',
  ADDITIONAL_INFORMATION_FROM_CUSTOMER = 'ADDITIONAL_INFORMATION_FROM_CUSTOMER',
  CARRIER_ELIGIBILITY = 'CARRIER_ELIGIBILITY',
  SPECIAL_AUTHORIZATION = 'SPECIAL_AUTHORIZATION',
  RULE_REVIEW = 'RULE_REVIEW',
  AUTO_MEDICAL_CLAIMS = 'AUTO_MEDICAL_CLAIMS',
  REINSTATEMENT_APPROVAL_LETTER = 'REINSTATEMENT_APPROVAL_LETTER',
  REINSTATEMENT_DECLINE_LETTER = 'REINSTATEMENT_DECLINE_LETTER',
  REINSTATEMENT_WITHDRAWN_LETTER = 'REINSTATEMENT_WITHDRAWN_LETTER',

  REINSTATEMENT_APPLICATION = 'REINSTATEMENT_APPLICATION',
  APS_SUMMARY = 'APS_SUMMARY',
  EHR_SUMMARY = 'EHR_SUMMARY',
  ADDITIONAL_DATA = 'ADDITIONAL_DATA',

  RUW_WITHDRAWL_LETTER = 'RUW_WITHDRAWL_LETTER',
  PLAN_F = 'PLAN_F',
  DISPUTE = 'DISPUTE',
  ADDITIONAL_DOCUMENTS = 'ADDITIONAL_DOCUMENTS',
}

// The ordering of these task categories defines the order that the evidences appear
// Default tasks should always be first, followed by TRL, Disclsorues, Rx, MIB, MVR, in that order
// All other tasks should be in the order of when they were created
export enum TaskCategory {
  DEFAULT_TASK,
  TRL_TASK,
  DISCLOSURE_TASK,
  RX_TASK,
  MIB_TASK,
  MVR_TASK,
  CARRIER_ELIGIBILITY_TASK,
  ADDITIONAL_DATA_TASK,
  MANUAL_TASK,
  // NOTES_TASK sorts after every other category so Notes always renders at the
  // bottom of the sidebar, right before the hardcoded Referral link.
  NOTES_TASK,
}

const {
  DEFAULT_TASK,
  TRL_TASK,
  DISCLOSURE_TASK,
  RX_TASK,
  MIB_TASK,
  MVR_TASK,
  CARRIER_ELIGIBILITY_TASK,
  MANUAL_TASK,
  NOTES_TASK,
} = TaskCategory;

export const TaskCategoryMapping: Record<TaskTypes, TaskCategory> = {
  SUMMARY: DEFAULT_TASK,
  DECISION: DEFAULT_TASK,
  OVERVIEW: DEFAULT_TASK,
  NOTES: NOTES_TASK,
  PIA: DEFAULT_TASK,
  RULE_RESULTS: DEFAULT_TASK,
  DOCTOR_INFO: DEFAULT_TASK,
  TRL: TRL_TASK,
  DISCLOSURE: DISCLOSURE_TASK,
  QE_DISCLOSURE: DISCLOSURE_TASK,
  RX: RX_TASK,
  MIB: MIB_TASK,
  MVR: MVR_TASK,
  MEDEXAM: MANUAL_TASK,
  APS: MANUAL_TASK,
  EHR: MANUAL_TASK,
  ETI: MANUAL_TASK,
  RULE_REVIEW: MANUAL_TASK,
  MIB_CODEBACK: MANUAL_TASK,
  ORDER_MIB_CODEBACK: MANUAL_TASK,
  LETTER: MANUAL_TASK,
  OTAF_LETTER: MANUAL_TASK,
  DECLINE_LETTER: MANUAL_TASK,
  LAB_PIQTURE: MANUAL_TASK,
  MEDICAL_CLAIMS: MANUAL_TASK,
  SCRIPT_CHECK: MANUAL_TASK,
  MIB_CODE_DETAILS: MANUAL_TASK,
  INSURANCE_LABS: MANUAL_TASK,
  CRIMINAL_RECORDS: MANUAL_TASK,
  SUBSTANDARD_LETTER: MANUAL_TASK,
  ADDITIONAL_INFORMATION_FROM_CUSTOMER: MANUAL_TASK,
  CARRIER_ELIGIBILITY: CARRIER_ELIGIBILITY_TASK,
  SPECIAL_AUTHORIZATION: MANUAL_TASK,
  PLAN_F: MANUAL_TASK,
  AUTO_MEDICAL_CLAIMS: MANUAL_TASK,
  REINSTATEMENT_APPROVAL_LETTER: MANUAL_TASK,
  REINSTATEMENT_DECLINE_LETTER: MANUAL_TASK,
  REINSTATEMENT_WITHDRAWN_LETTER: MANUAL_TASK,
  REINSTATEMENT_APPLICATION: MANUAL_TASK,
  APS_SUMMARY: MANUAL_TASK,
  EHR_SUMMARY: MANUAL_TASK,
  ADDITIONAL_DATA: MANUAL_TASK,

  RUW_WITHDRAWL_LETTER: MANUAL_TASK,
  DISPUTE: MANUAL_TASK,
  ADDITIONAL_DOCUMENTS: MANUAL_TASK,
};

export const TaskTypeToTaskTitleMapping: Record<TaskTypes, string> = {
  SUMMARY: Resource.SUMMARY,
  DECISION: Resource.TASK_TITLE_DECISION,
  OVERVIEW: Resource.TASK_TITLE_OVERVIEW,
  NOTES: Resource.TASK_TITLE_NOTES,
  PIA: Resource.TASK_TITLE_PIA,
  MIB: Resource.TASK_TITLE_MIB,
  TRL: Resource.TASK_TITLE_TRL,
  MVR: Resource.TASK_TITLE_MVR,
  LETTER: Resource.TASK_TITLE_LETTER,
  OTAF_LETTER: Resource.TASK_TITLE_LETTER,
  DECLINE_LETTER: Resource.TASK_TITLE_LETTER,
  RX: Resource.TASK_TITLE_RX,
  DISCLOSURE: Resource.TASK_TITLE_DISCLOSURE,
  QE_DISCLOSURE: Resource.TASK_TITLE_DISCLOSURE,
  MEDEXAM: Resource.TASK_TITLE_MEDEXAM,
  APS: Resource.TASK_TITLE_APS,
  EHR: Resource.TASK_TITLE_EHR,
  ETI: Resource.TASK_TITLE_ETI,
  RULE_REVIEW: Resource.TASK_TITLE_RULE_REVIEW,
  MIB_CODEBACK: Resource.TASK_TITLE_MIB_CODEBACK,
  ORDER_MIB_CODEBACK: Resource.TASK_TITLE_ORDER_MIB_CODEBACK,
  LAB_PIQTURE: Resource.TASK_TITLE_LAB_PIQTURE,
  MEDICAL_CLAIMS: Resource.TASK_TITLE_MEDICAL_CLAIMS,
  SCRIPT_CHECK: Resource.TASK_TITLE_SCRIPT_CHECK,
  MIB_CODE_DETAILS: Resource.TASK_TITLE_MIB_CODE_DETAILS,
  INSURANCE_LABS: Resource.TASK_TITLE_INSURANCE_LABS,
  CRIMINAL_RECORDS: Resource.TASK_TITLE_CRIMINAL_RECORDS,
  SUBSTANDARD_LETTER: Resource.TASK_TITLE_LETTER,
  RULE_RESULTS: Resource.RULE_RESULTS_TITLE,
  ADDITIONAL_INFORMATION_FROM_CUSTOMER:
    Resource.TASK_TITLE_ADDITIONAL_CUSTOMER_INFO,
  CARRIER_ELIGIBILITY: Resource.TASK_TITLE_CARRIER_ELIGIBILITY,
  SPECIAL_AUTHORIZATION: Resource.TASK_TITLE_SPECIAL_AUTHORIZATION,
  PLAN_F: Resource.TASK_TITLE_PLAN_F,
  AUTO_MEDICAL_CLAIMS: Resource.TASK_TITLE_AUTO_MEDICAL_CLAIMS,
  REINSTATEMENT_APPROVAL_LETTER: Resource.TASK_TITLE_LETTER,
  REINSTATEMENT_DECLINE_LETTER: Resource.TASK_TITLE_LETTER,
  REINSTATEMENT_WITHDRAWN_LETTER: Resource.TASK_TITLE_LETTER,
  REINSTATEMENT_APPLICATION: Resource.TASK_TITLE_REINSTATEMENT_APPLICATION,
  APS_SUMMARY: Resource.TASK_TITLE_APS_SUMMARY,
  EHR_SUMMARY: Resource.TASK_TITLE_EHR_SUMMARY,
  ADDITIONAL_DATA: Resource.TASK_TITLE_ADDITIONAL_DATA,
  DOCTOR_INFO: Resource.DOCTOR_INFO_TITLE,
  RUW_WITHDRAWL_LETTER: Resource.RUW_WITHDRAWL_LETTER,
  DISPUTE: Resource.TASK_TITLE_DISPUTE,
  ADDITIONAL_DOCUMENTS: Resource.TASK_TITLE_ADDITIONAL_DOCUMENTS,
};

export const CaseManagerExcludedTaskTypes = [
  TaskTypes.SPECIAL_AUTHORIZATION,
  TaskTypes.PLAN_F,
  TaskTypes.MIB_CODE_DETAILS,
  TaskTypes.ADDITIONAL_INFORMATION_FROM_CUSTOMER,
  TaskTypes.ADDITIONAL_DOCUMENTS,
];

export const CopilotTasks: TaskTypes[] = [
  TaskTypes.AUTO_MEDICAL_CLAIMS,
  TaskTypes.RX,
  TaskTypes.APS,
  TaskTypes.DISCLOSURE,
];

export enum PromptType {
  PlainText = 'PlainText',
  GridView = 'GridView',
  ChartView = 'ChartView',
  // Disclosure vs RX vs DX
  CompareDisclosure = 'CompareDisclosure',
  // Disclosure vs DX vs APS
  CompareDisclosureDxAPS = 'CompareDisclosureDxAPS',
  // Disclosure vs APS
  CompareDisclosureAPS = 'CompareDisclosureAPS',
}

// TODO: Delete TaskTypeToPromptTypeMapping config after confirming with the Project Manager (PM) - RP-1156.
export const TaskTypeToPromptTypeMapping: Map<TaskTypes, PromptType[]> =
  new Map([
    [TaskTypes.AUTO_MEDICAL_CLAIMS, []],
    [TaskTypes.CRIMINAL_RECORDS, []],
    [TaskTypes.RX, []],
    [TaskTypes.MIB, []],
    [TaskTypes.MVR, []],
  ]);

export const PromptTypeToTitleMapping: Map<PromptType, string> = new Map([
  [PromptType.CompareDisclosure, 'Birds eye view (Medical conditions)'],
  [PromptType.CompareDisclosureDxAPS, 'Birds eye view (Medical conditions)'],
  [PromptType.CompareDisclosureAPS, 'Birds eye view (Lab vitals)'],
]);

export const PromptTypeTaskTypesMapping: Map<PromptType, TaskTypes[]> = new Map(
  [
    [
      PromptType.CompareDisclosure,
      [TaskTypes.DISCLOSURE, TaskTypes.RX, TaskTypes.AUTO_MEDICAL_CLAIMS],
    ],
    [
      PromptType.CompareDisclosureDxAPS,
      [TaskTypes.DISCLOSURE, TaskTypes.AUTO_MEDICAL_CLAIMS, TaskTypes.APS],
    ],
    [PromptType.CompareDisclosureAPS, [TaskTypes.DISCLOSURE, TaskTypes.APS]],
  ],
);
